import React, { useContext, useEffect } from "react";
import { AppContext } from "../States/AppContext";
import { Link } from "react-router-dom";

import alarmWave from "../../img/waveforms/alarms/alarml2.mp4";
import plethflat from "../../img/waveforms/pleth-flat4.mp4";
import v2 from "../../img/icons/v22.png";
import v2vod from "../../img/waveforms/ezgif.com-gif-to-mp4.mp4";
import VideoPlayer from "../Common/VideoPlayer";

const SecondaryWave = () => {
  const { state, setState } = useContext(AppContext);

  const secondary = state.waveData.filter((wav) => wav.secondary === true);

  useEffect(() => {
    if (!state.ecg && state.spoContinuous) {
      const timeoutId = setTimeout(() => {
        setState((prevState) => {
          const updatedWave = prevState.waveData.map((wave) => {
            if (wave.buttonName === "Pleth") {
              return { ...wave, secondary: true };
            } else {
              return { ...wave, secondary: false };
            }
          });
          return {
            ...prevState,
            waveData: updatedWave,

            // waveChangesTest:true
          };
        }, 0);

        return () => clearTimeout(timeoutId);
      });
    }
  }, [!state.ecg]);

  return (
    <>
      <Link
        to="/settings/changewave2"
        style={{ gridArea: "wave2", position: "relative", background: "black" }}
      >
        <div
          key={secondary.name}
          style={{ display: "grid", placeItems: "center" }}
        >
          {state.ecgOffWave2 === true && state.spoContinuous ? (
            <VideoPlayer
              src={secondary[0].vid}
              loop={true}
            />
          ) : state.ecgOffWave2 === true && !state.spoContinuous ? (
            <VideoPlayer
              src={secondary[0].vid}
              loop={true}
              ecgOff={true}
            />
          ) : state.initiateAlarms ? (
            <>
              <VideoPlayer
                src={alarmWave}
                loop={true}
              >
                <img
                  src={v2}
                  style={{
                    position: "absolute",
                    height: "15px",
                    top: "-2%",
                    left: "-40%",
                  }}
                />
              </VideoPlayer>
            </>
          ) : secondary[0].name === "Pleth" && !state.spoContinuous ? (
            <VideoPlayer
              src={plethflat}
              loop={true}
            />
          ) : (
            <VideoPlayer
              src={secondary[0].vid}
              loop={true}
            />
          )}
        </div>
      </Link>
    </>
  );
};

export default SecondaryWave;
